/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Search_Criteria_Label_Salary_MinInputs */

const en_jobs_search_criteria_label_salary_min = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary Min`)
};

const de_jobs_search_criteria_label_salary_min = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehalt Min`)
};

const fr_jobs_search_criteria_label_salary_min = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salaire min`)
};

const es_jobs_search_criteria_label_salary_min = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salario mín.`)
};

const it_jobs_search_criteria_label_salary_min = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stipendio min`)
};

const nl_jobs_search_criteria_label_salary_min = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salaris min`)
};

const pl_jobs_search_criteria_label_salary_min = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wynagrodzenie min`)
};

const fi_jobs_search_criteria_label_salary_min = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palkka min`)
};

const da_jobs_search_criteria_label_salary_min = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Løn min`)
};

const sv_jobs_search_criteria_label_salary_min = /** @type {(inputs: Jobs_Search_Criteria_Label_Salary_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lön min`)
};

/**
* | output |
* | --- |
* | "Salary Min" |
*
* @param {Jobs_Search_Criteria_Label_Salary_MinInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_search_criteria_label_salary_min = /** @type {((inputs?: Jobs_Search_Criteria_Label_Salary_MinInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Search_Criteria_Label_Salary_MinInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_search_criteria_label_salary_min(inputs)
	if (locale === "fr") return fr_jobs_search_criteria_label_salary_min(inputs)
	if (locale === "es") return es_jobs_search_criteria_label_salary_min(inputs)
	if (locale === "it") return it_jobs_search_criteria_label_salary_min(inputs)
	if (locale === "nl") return nl_jobs_search_criteria_label_salary_min(inputs)
	if (locale === "pl") return pl_jobs_search_criteria_label_salary_min(inputs)
	if (locale === "fi") return fi_jobs_search_criteria_label_salary_min(inputs)
	if (locale === "da") return da_jobs_search_criteria_label_salary_min(inputs)
	if (locale === "sv") return sv_jobs_search_criteria_label_salary_min(inputs)
	return en_jobs_search_criteria_label_salary_min(inputs)
});